import api from '../../services/api';
import { Creators } from '../ducks/bar_chart';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getBarChart({ filter }) {
  try {
    let response;

    yield put(Creators.barChartRequest());
    response = yield call(api.post, 'bar-chart', filter);

    yield put(Creators.barChartSuccess(response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.barChartError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao buscar dados do gráfico de faturamento x vendas'
    }));
  }
}